import { render, staticRenderFns } from "./BaseFormErrors.vue?vue&type=template&id=6134ffc5&scoped=true&"
import script from "./BaseFormErrors.vue?vue&type=script&lang=js&"
export * from "./BaseFormErrors.vue?vue&type=script&lang=js&"
import style0 from "./BaseFormErrors.vue?vue&type=style&index=0&id=6134ffc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6134ffc5",
  null
  
)

export default component.exports